import { render, staticRenderFns } from "./SampleDatabaseSidebar.vue?vue&type=template&id=4b3c1be2&scoped=true"
import script from "./SampleDatabaseSidebar.vue?vue&type=script&lang=js"
export * from "./SampleDatabaseSidebar.vue?vue&type=script&lang=js"
import style0 from "./SampleDatabaseSidebar.vue?vue&type=style&index=0&id=4b3c1be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3c1be2",
  null
  
)

export default component.exports